'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssifyObject;

var _hyphenateStyleName = require('hyphenate-style-name');

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _warning = require('./warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * generates a valid CSS string containing style
 *
 * @param {Object} style - object containing CSS declarations
 * @returns {string} valid CSS string with dash cased properties
 */
/*  weak */
function cssifyObject(style) {
  return Object.keys(style).reduce(function (css, prop) {
    // warn if invalid values are rendered
    process.env.NODE_ENV !== "production" ? (0, _warning2.default)(typeof style[prop] === 'string' || typeof style[prop] === 'number', 'The invalid value `' + style[prop] + '` has been used as `' + prop + '`.') : void 0;

    // prevents the semicolon after
    // the last rule declaration
    if (css.length > 0) {
      css += ';';
    }

    css += (0, _hyphenateStyleName2.default)(prop) + ':' + style[prop];
    return css;
  }, '');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/cssifyObject.js
// module id = 442
// module chunks = 0